import { Tag } from '@cian/components';
import * as React from 'react';

import { IFloorTag } from '../../../state/tags/definitions/floor';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IFloorTagItemProps {
  tag: IFloorTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const FloorTagItem = ({ tag, onDeleteClick, withNewTag }: IFloorTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);
  let text = [];

  if (tag.min !== undefined) {
    text.push(`от ${tag.min}`);
  }

  if (tag.max !== undefined) {
    text.push(`до ${tag.max}`);
  }

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Этаж {text.join(' ')}
    </TagComponent>
  );
};
